import script from "./univBox.vue?vue&type=script&setup=true&lang=js"
export * from "./univBox.vue?vue&type=script&setup=true&lang=js"

import "./univBox.vue?vue&type=style&index=0&id=5de9a326&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de9a326"]])

export default __exports__